<template>
  <div>
      <div v-if="isAddress && isFirstTime && available_data.business_type && available_data.business_type!='virtual'">
          <booking-view-map
              :type-id="bookingId"
              :item-type="itemType"
              :booking-id="bookingId"
              :show-address="showAddress"
              :line-address="lineAddress"
              :booking-address='bookingAddress'
              :is-address="isAddress"
              :available-contractors="availableContractors"
          ></booking-view-map>
      </div>
      <div v-else-if="available_data && available_data.business_type && available_data.business_type!='virtual'">
          <div style="" class="noRowsMessageDIV">No address for this booking added
              <div style="font-size:12px; margin-top:6px;">
<!--                  <?php if ($hasViewBookingCredential): ?>-->
<!--                  <a href="<?php echo $this->escape($this->url(array('id' => $this->booking['booking_id']), 'bookingView')); ?>">View Booking</a>-->
<!--                  <?php endif; ?>-->
              </div>
          </div>
      </div>
    <div class="table-responsive">
      <table :id="tableId" ref="available-table" class="table table-hover">
        <thead>
        <tr class="info heading-row">
          <th>{{ labelWorkersName }}</th>
          <th>Distance <span class="block">({{ available_data?available_data.unit:'' }})</span></th>
          <th v-if="!fromJobRequestForm">Cost <a href="javascript:;" @click="popupiHelperText"> <i class="fa fa-info-circle fa-lg"></i></a></th>
          <th  >Status</th>
          <th v-if="fromJobRequestForm">Mobile</th>
          <th>Date sent</th>
          <th>
            <div v-if="fromJobRequestForm" class="material-switch material-switch-job">
              <input id="all-sms-job-request-mobiles" type="checkbox" checked @change="allSmsChanged"/><label
                for="all-sms-job-request-mobiles" class="label-default"></label>
            </div>
          </th>
        </tr>
        </thead>
        <tbody>
          <tr v-for="(contractorDistance,index) of contractorDistances" :key="index">
            <td>
              <div class="row fieldworker-hover" :data-contractor_id = "contractorDistance.user_id" :data-uid="available_data.booking_id+contractorDistance.user_id"
                   :data-item_type="available_data.itemType"
                   :data-item_id="available_data.itemId">
                <div class="col-md-2 contractor-img p-top-10">
                  <img class="contractor_pic_small" :src="getImageSrc(contractorDistance)" width="30" height="30"/>
                </div>
                <div class="col-md-9">
                  <div>
                    <span>{{ contractorDistance.username }}</span>
                    <span class="caret"></span>
                  </div>
                  <div>
                    <span v-for="index in 5" :class="contractorDistance.contractor_rate >= index?'fa fa-star':'fa fa-star-o' " ></span>
                  </div>
                </div>
              </div>
              <div :id="available_data.booking_id+contractorDistance.user_id" class="summary-onhover summary-onhover-mobile loading" style="display:none;padding-bottom: unset;">
                <div style="padding-left: 100px;" ><img src="/pic/loading-4.gif" style="display:block" id="loading_img_2"></div>
              </div>
            </td>
            <td>{{ contractorDistance.distance }}</td>
            <td v-if="!fromJobRequestForm">{{ contractorDistance.currency_symbol}}{{ contractorDistance.share }}</td>
            <td >
                <a data-toggle="modal" :data-target="contractorDistance.reaction_status != 'Declined' ? `#declineBookingRequest${contractorDistance.user_id}` :' '  ">
                <span class="job-status-icon" v-if="contractorDistance.reaction_status"
                    :style="`background-color: ${ contractorDistance.status_color }`">
                    <img height="8" width="8"
                         :src="`/pic/white_${ contractorDistance.status_icon }.png`"
                         :title="contractorDistance.reaction_status"
                         :alt="contractorDistance.reaction_status">
              </span>
                </a>
            </td>

            <td v-if="fromJobRequestForm">{{ contractorDistance.mobile1 }}</td>
            <td>
              <span v-if="contractorDistance.reaction_status" style="cursor:default" :title="contractorDistance.full_date">
                {{ contractorDistance.time }}</span>
            </td>
            <td>
              <div v-if="fromJobRequestForm" class="material-switch material-switch-job material-switch-mobiles">
                <input  type="checkbox"    :checked="contractorDistance.reaction_status != 'Declined'" class="sms-job-request-mobiles" :data-id="contractorDistance.user_id" @change="mobilesChanged"
                       :data-mobile="contractorDistance.mobile1" :id="`sms-job-request-mobile${index}`" >
                <label :for="`sms-job-request-mobile${index}`" class="label-default"></label>
                <input type='hidden' name="contractorTabelData" :value="JSON.stringify(contractorTabelData)"/>
              </div>
                <div v-else class="btn-group pair_btn_new_uniq left-12">
                    <button data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="actions-btn btn btn-default three-dots-btn gh_customer_name dropdown-toggle" style="padding: 0px !important;">
                        <i class="fa fa-ellipsis-v" style="color: rgb(138, 138, 138); font-size: 18px;"></i>
                    </button>

                    <ul class="dropdown-menu pair_of_all_li w_und_767 mobile-right-8" id="pair_of_all_li" style="right: 0; left: auto;">
                        <li v-if="isBooking">
                            <a class="assign-job" :data-id="contractorDistance.user_id">
                                <span title="Assign job" class="assign-job-icon"><i class="fa fa-tasks"></i></span>
                                <span> Assign job</span>
                            </a>
                        </li>
                        <li v-if="(contractorDistance.reaction_status!='Accepted' || isAssignedGeneral) && isBooking" class="divider"></li>
                        <li v-if="(contractorDistance.reaction_status!='Accepted' || isAssignedGeneral) && isBooking">

                          <div v-if="countActiveServices>1 || countVisits>1">
                            <a title="Send request" style="cursor: pointer" data-toggle="modal" data-target="#contractor_job_request_modal" @click="fillContractorJobRequestModal($event)"
                                  :data-contractor_id="contractorDistance.user_id" :data-contractor_name="contractorDistance.username"
                                  class="send-job-request-icon send-contractor-job-request">
                              <span><i class="fa fa-repeat"></i></span>
                              <span>Send job request</span>
                            </a>
                                <div class="hidden" :id="`fieldworker_request_content_${contractorDistance.user_id}`">
                                    <div class="row">
                                        <ul class="fieldworker-requests-list">
                                            <input type="hidden" name="job_contractor_id" v-model="contractorDistance.user_id"/>
                                            <li><input type="checkbox" name="job_multiple_day_ids[]" value="all_booking" class="job_request_check job_all_booking" />
                                                All appointments
                                            </li>
                                            <li v-for="contractorService in contractorDistance.services">
                                                <input type="checkbox" class="job_request_check job_service"/><strong>{{ contractorService.service_name }}</strong>
                                                <ul>
                                                    <li v-for="visit in contractorService.visits" class="child-node">
                                                      <input type="checkbox" name="job_multiple_day_ids[]"
                                                          :data-assigned_general="assignedGeneral(visit.contractor_id)"  :data-appointment_name="`${contractorService.service_name} ${visit.date_string}`"
                                                             :value="visit.multiple_day_id" class="job_request_check job_appontment"/>{{ visit.date_string }}
                                                    </li>
                                                </ul>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                          <a v-else class="send-job-request-icon send-contractor-job-request" :data-id="contractorDistance.user_id"
                             @click="sendJobRequestForContractor(contractorDistance.user_id,$event.target,[],isAssignedGeneral)">
                            <span><i class="fa fa-repeat"></i></span>
                            <span> Send job request</span>
                          </a>

                        </li>
                        <li class="divider"></li>
                        <li>
                            <a @click="openCalendarLink(contractorDistance.calendar_link)">
                                <span><i class="fa fa-calendar"></i></span>
                                <span>Calendar</span>
                            </a>
                        </li>

                    </ul>
                </div>
            </td>

              <confirmation-popup
                  title="Decline booking"
                  :id="`declineBookingRequest${contractorDistance.user_id}`"
                  confirm-btn-text="Yes"
                  cancel-btn-text="Cancel"
                  @on-confirm="declineBookingRequest(contractorDistance,available_data.booking_id)"
                  custom-optional-class="admin_declineBookingRequest"   >
                   Are you sure you want to decline  this booking for {{contractorDistance.username}}?

              </confirmation-popup>


          </tr>
        </tbody>
      </table>
    </div>
    <confirmation-popup :title="`Send job request to`" id="contractor_job_request_modal" confirm-btn-text="Send"
                        cancel-btn-text="Close" @on-confirm="sendJobAppointment">
    </confirmation-popup>



  </div>
</template>
<script>


export default {
  name: "AvailableFieldworkersTable",
  components: {},
  props: {
    tableId:{
      type: String,
      default(){
        return "available_fieldworker_table"
      }
    },
    itemType: {
        type: String,
        required: true
    },
    contractorDistances: {
      type: Array,
    },
    available_data: {
      type: Object
    },
    fromJobRequestForm:{
        //From job request form
      type: Boolean,
      default(){
        return false
      }
    },
    countActiveServices: {
      type: Number,
      default(){
        return 0
      }
    },
      lineAddress: {
          type: Array,
          required: false,
          default() {
              return []
          }
      },
      bookingAddress: {
          type: Array,
          required: false,
          default() {
              return []
          }
      },
      showAddress: {
          required: false
      },
      availableContractors: {
          type: Array,
          required: false,
          default() {
              return []
          }
      },
    isAddress:false,
    isCollapsed: false,
    isFirstTime: false,
    bookingId: {
      type: Number,
    },
  },
  data(){
    return {
      tableInitialized: false,
      table:null,
      table1Options: {
        paging: false,
        searching: false,
        columnDefs: [
          { "orderable": false, "targets": this.unorderable }
        ],
        order:[1,"asc"],
      }
    }
  },
  computed:{
    unorderable(){
      return this.fromJobRequestForm?[4]:[5]
    },
    contractorTabelData(){
      let contractorsData = []
      this.contractorDistances.forEach((contractor1)=>{
        contractorsData.push({contractor_id: contractor1.user_id,distance: contractor1.distance,share: contractor1.share})
      })
      return contractorsData
    },
    isBooking(){
      return this.available_data && this.available_data.itemType==='booking'
    },
    isAssignedGeneral(){
      return this.available_data && this.available_data.is_assigned_general
    },
    countVisits(){
      return this.available_data && this.available_data.countVisits
    },
    labelWorkersName(){
      return this.available_data?this.available_data.labelWorkersNameSingular:''
    }
  },
  methods:{
    declineBookingRequest(contractorDistance,bookingId){
         // this.contractorDistances= this.contractorDistances.filter(item => item.user_id != 24);
     let URL =`/webservice/decline-request-on-fieldworker-behalf?booking_id=${bookingId}&contractor_id=${contractorDistance.user_id}`;
          window.axios.get(URL).then(function (response) {
              if (response.data.type === 'success') {
                   //$.notify(response.data.message, 'success');
              }else{
                 // $.notify(response.data.message, 'error');
              }

          });
          this.contractorDistances.forEach(item => {

              if (item.user_id == contractorDistance.user_id ) {

                  item.status_icon = "rejected";
                  item.status_color = "rgb(255, 0, 0);";
                  item.reaction_status = "Declined";
              }
          });

      },
    popupiHelperText(){
      window.popupi_helper_text()
    },
    allSmsChanged(event){
      $("input:checkbox.sms-job-request-mobiles").prop('checked', $(event.target).prop("checked"));
    },
    mobilesChanged(event){
      if(!$(event.target).is(":checked")){
        $("#all-sms-job-request-mobiles").prop("checked",false);
      }else{
        if($(".sms-job-request-mobiles").length === $(".sms-job-request-mobiles:checked").length)
          $("#all-sms-job-request-mobiles").prop("checked",true);
      }
    },
    openCalendarLink(link){
      window.open(`${link}`, '_blank')
    },
    fillContractorJobRequestModal(event){

      let btn = $(event.target).parent();
      let contractor_name = btn.data("contractor_name");
      let contractor_id = btn.data("contractor_id");
      let modal = $("#contractor_job_request_modal");
      let vm = this
      modal.find(".modal-title").html("Send job request to "+contractor_name);
      modal.find(".modal-body").html($("#fieldworker_request_content_"+contractor_id).html());
      modal.find(".modal-body").find("input[type=checkbox]").each(function(){
        $(this).on("change", vm.jobRequestChecked); // Add event listeners
      })
      modal.find("button.btn-confirm").addClass("send-job-appointment")
    },
    jobRequestChecked(event){
      let input = $(event.target);
      if(input.hasClass("job_all_booking")){
        if(input.is(":checked")){
          input.closest(".fieldworker-requests-list").find(".job_request_check").not(event.target).prop('checked',false).prop("disabled",true);
        }else
          input.closest(".fieldworker-requests-list").find(".job_request_check").not(event.target).prop("disabled",false);
      }else if(input.hasClass("job_service")){
        if(input.is(":checked")){
          input.parent().find(".job_appontment").prop('checked',true);
        }else
          input.parent().find(".job_appontment").prop("checked",false);
      }else if(input.hasClass("job_appontment")){
        if(input.is(":checked")){
          if(input.closest("ul").find(".job_appontment:checked").length==
              input.closest("ul").find(".job_appontment").length)
            input.closest("ul").closest("li").find(".job_service").prop('checked',true);
        }else{
          input.closest("ul").closest("li").find(".job_service").prop("checked",false);
        }

      }
    },
    assignedGeneral(visitContractorId){
      return this.available_data && this.available_data.general_user_id === visitContractorId
    },
    sendJobAppointment(event){
      let is_assigned_general = this.isAssignedGeneral;
      let not_assigned_appointments = [];
      let modal = $("#contractor_job_request_modal")
      let contractor_id = modal.find("input[name='job_contractor_id']").val()
      let multiple_day_ids = modal.find("input[name='job_multiple_day_ids[]']:checked")
          .map(function(){
            if(!$(this).data("assigned_general")&&$(this).val()!='all_booking'){
              is_assigned_general = 0;
              not_assigned_appointments.push($(this).data("appointment_name"));
            }
            return $(this).val();
          }).get();
      this.sendJobRequestForContractor(contractor_id,event.target,multiple_day_ids,is_assigned_general,not_assigned_appointments);
    },
    // send job request for exact contractor
    sendJobRequestForContractor(contractor_id,this1,multiple_day_ids=[],is_assigned_general,not_assigned_appointments=[]){

      let job_request_button = $(this1);
      if(!is_assigned_general){
        let not_assigned_message = "this booking";
        $("#sms-job-request-modal").modal("hide");
        if(not_assigned_appointments){
          not_assigned_message = not_assigned_appointments.join(',');
        }
        confirm_popup({title : 'Send request',
              message :  `This will unassign ${not_assigned_message} and return it to general ${this.labelWorkersName} for the request process to start again, are you sure you want to continue?`,
              confirm : 'Confirm',
              cancel: 'Cancel', alert: true },
            function () {
              window.confirmed_to_unassign = 1;
              window.SendJobRequest(contractor_id,null,true,this1,multiple_day_ids);
            });
      }else{
        window.SendJobRequest(contractor_id,null,true,this1,multiple_day_ids);
      }
    },
      getImageSrc(contractorDistance) {
          if (!this.isCollapsed && typeof(this.isCollapsed) != 'undefined') {
              return contractorDistance.avatar;
          }
          return '';
      },
  },
  mounted() {      },
  watch: {
    contractorDistances: {
      handler(contractors) {
          this.$nextTick(function(){
            if(!this.tableInitialized){
              this.table = $(this.$refs['available-table']).DataTable(this.table1Options);
              this.tableInitialized = true
            }else{
              var rowCount = this.contractorDistances.length;
              $(this.$refs['available-table']).parent().find(".dataTables_info").html("Showing " + rowCount + " records");
            }
            if(typeof (fieldworkerPopover)!="undefined"){
                fieldworkerPopover.init($(".fieldworker-hover"),this.available_data.contractor_url);

            }
          })
      }
    }
  }
}
</script>
<style scoped>
.table-responsive{
  padding:10px; margin:0px;
}
.table-responsive .table{
  text-align:center; vertical-align:middle;font-size:12px;
  vertical-align: middle;
}
tr.heading-row{
  font-weight:bold;
}
.material-switch-mobiles{
  position: relative;
  left: -22px;
}
.job-status-icon {
  position: relative;
  border-radius: 50%;
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 4px;
  padding-bottom: 6px;
  margin-right: 1px;
}

.admin_declineBookingRequest{
    background: red !important ;
    z-index: 1950 !important ;
}
</style>